var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('header',[_c('div',{staticClass:"header"},[_c('BaseHeader',{attrs:{"title":'详情'}})],1)]),_c('div',{staticClass:"content nows mycontent"},[_c('h3',{staticStyle:{"text-align":"center","margin-bottom":"-30px"}},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }